module.exports = "\r\n<div class=\"container-fluid\">\r\n<router-outlet>\r\n</router-outlet>\r\n</div>\r\n\r\n"